// @flow
import FilterModel from "../filters/FilterModel";

import CompositeAttributeModel from "../attributes/CompositeAttributeModel";
import type { AttributeType, IFilter } from "../types";

/**
 * Range filter, for instance a date range filter or a number range filter
 */
export default class RangeFilterModel extends FilterModel implements IFilter {
  /**
   */
  update(attribute: AttributeType, value: string) {
    if (this.attribute instanceof CompositeAttributeModel) {
      this.attribute.update(value, attribute);
    } else if (this.attribute != null) {
      this.attribute.update(value);
    }
  }

  /**
   */
  get params(): Array<{ name: string, value: ?string }> {
    if (this.attribute instanceof CompositeAttributeModel) {
      return this.attribute.children.map((child) => {
        const { param } = this.data[child.name];
        return {
          name: param,
          value: child.value,
        };
      });
    }

    return [];
  }

  /**
   */
  get formdata(): { [string]: any } | null {
    if (this.attribute instanceof CompositeAttributeModel) {
      const formdata = {};
      for (const child of this.attribute.children.all) {
        const { param } = this.data[child.name];
        if (child.value) {
          formdata[param] = child.value;
        }
      }
      if (Object.keys(formdata).length > 0) {
        return { ...formdata };
      }
    }
    return null;
  }
}
